import { render, staticRenderFns } from "./PersonalPeripheral.vue?vue&type=template&id=392df8cc&"
import script from "./PersonalPeripheral.vue?vue&type=script&lang=ts&"
export * from "./PersonalPeripheral.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalPeripheral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalPeripheral.vue"
export default component.exports